import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Region } from "../../config/types";

const initialState:Region[] =[]

export const state = createSlice({
  name: "regions",
  initialState,
  reducers: {
    addRegionList: (_state, action: PayloadAction<Region[]>) => {
    return action.payload;


    },
  },
});
export const { addRegionList } = state.actions;

export default state.reducer;
